import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Field from '../../../../../../../../../../../../components/Form/Field'
import FieldLabelWrapper from '../../../../../../../../../../../../features/components/Form/FieldLabelWrapper'

import { selectedPartnershipSelector } from '../../../../../../../../../../../../modules/selectors/partnerships'

import { getRateFieldLabel, getAllocationInfo, getAllocationSymbol } from '../../../helpers'

import { ALLOCATION_TYPE, allocationTypes, GOOGLE_AD_MANAGER_AD_ACCOUNT } from '../../../../fields'
import { ALLOCATION } from '../fields'

const SingleAllocationFields = ({ formik }) => {
  const { t } = useTranslation()
  const { [GOOGLE_AD_MANAGER_AD_ACCOUNT]: gamAccount } = useSelector(selectedPartnershipSelector)

  const { values } = formik

  const { allocationType, allocationGroup, billingEventType, isPercentageAllocation } = getAllocationInfo(values)
  const allocationFieldPath = `${allocationGroup}.${ALLOCATION}`

  return (
    <>
      <FieldLabelWrapper label={values[ALLOCATION_TYPE] === allocationTypes.budget ? t('Budget') : t('Allocation')}>
        <Field
          formik={formik}
          key={allocationFieldPath}
          name={allocationFieldPath}
          placeholder="Allocation"
          type="number"
          symbol={getAllocationSymbol(isPercentageAllocation, allocationType, gamAccount?.currency_symbol)}
          symbolPosition={isPercentageAllocation ? 'end' : 'start'}
        />
      </FieldLabelWrapper>

      <FieldLabelWrapper label={`${getRateFieldLabel(billingEventType)} rate`}>
        <Field
          formik={formik}
          name={billingEventType}
          key={billingEventType}
          placeholder={getRateFieldLabel(billingEventType)}
          type="number"
          symbol={gamAccount?.currency_symbol}
          disablePlaceholderFormatting={true}
        />
      </FieldLabelWrapper>
    </>
  )
}

export default SingleAllocationFields
